/** Only this authored ability is a fixed self field. Other buffs do not
 * acquire area mechanics merely by sharing a target label. */
export const isSelfDamageField = (abilityId: string): boolean => abilityId === 'windfury_totem';
export interface SelfDamageField {
  kind: 'self_damage_field'; x: number; y: number; radius: number;
}

export function readSelfDamageField(value: unknown): SelfDamageField | null {
  if (!value || typeof value !== 'object') return null;
  const field = value as SelfDamageField;
  return field.kind === 'self_damage_field' && [field.x, field.y, field.radius].every(Number.isFinite)
    && field.radius > 0 ? { kind: field.kind, x: field.x, y: field.y, radius: field.radius } : null;
}

/** Membership uses authoritative body centres and an inclusive boundary. */
export function insideSelfDamageField(field: SelfDamageField, point: { x: number; y: number }): boolean {
  return Number.isFinite(point.x) && Number.isFinite(point.y)
    && Math.hypot(point.x - field.x, point.y - field.y) <= field.radius;
}
